module.exports = __webpack_public_path__ + "img/FIRMA_LOGIGAS.4b991100.png";